import { Input } from "@/components/ui/input";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/library/card";
import FormField from "@/components/ui/others/FormField";
import { useEducation } from "../../context/EducationContext";

export default function ChoiceDetailsCard() {
  const { register, isAllowCustomName, watch } = useEducation();
  const currentName = watch("name");

  return (
    <Card className="bg-white border-[#e6e8e7] rounded-[16px] gap-4 p-4 shadow-none">
      <CardHeader className="px-0 pb-0">
        <CardTitle className="text-[16px] font-medium text-black tracking-[-0.32px] leading-normal">
          Choice details
        </CardTitle>
      </CardHeader>
      <CardContent className="px-0 pt-0">
        <div className="pl-2 w-full">
          <FormField label={"Choice name"}>
            {isAllowCustomName ? (
              <Input
                id="choice-name"
                {...register("name")}
                placeholder="e.g. Harvard university I"
                className="bg-[rgba(255,255,255,0.7)] border-[#cdd1d0] h-10 rounded-xl pl-3 pr-2 py-3 text-sm text-[#505e59] tracking-[-0.56px]"
              />
            ) : (
              <div className="bg-gray-50 border border-[#cdd1d0] h-10 rounded-xl pl-3 pr-2 py-3 flex items-center">
                <span className="text-sm text-[#505e59] tracking-[-0.56px]">
                  {currentName}
                </span>
              </div>
            )}
          </FormField>
        </div>
      </CardContent>
    </Card>
  );
}
